import { InformationCircleIcon } from "@heroicons/react/24/solid";
import { t } from "@lingui/core/macro";
import { createFileRoute } from "@tanstack/react-router";
import { useSelector } from "react-redux";

import { selectAppSettings } from "@/redux/app/appSelectors";
import { Card } from "@/shared/components/ui/card";
import { CardContent } from "@/shared/components/ui/card";
import { CardDescription } from "@/shared/components/ui/card";
import { CardHeader } from "@/shared/components/ui/card";
import { CardTitle } from "@/shared/components/ui/card";
import { Table } from "@/shared/components/ui/table";
import { TableBody } from "@/shared/components/ui/table";
import { TableCaption } from "@/shared/components/ui/table";
import { TableCell } from "@/shared/components/ui/table";
import { TableHead } from "@/shared/components/ui/table";
import { TableHeader } from "@/shared/components/ui/table";
import { TableRow } from "@/shared/components/ui/table";
import { FEE_SCHEDULE } from "@/util/feeSchedule";
import { formatCurrencyCompact } from "@/util/numberUtils";

function FeeTable() {
  const appSettings = useSelector(selectAppSettings);
  const formattedMinAmount = formatCurrencyCompact(appSettings?.purchaseConstants?.minimumPurchaseAmount ?? 1_000);

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-primary">{t`Spreads`}</CardTitle>
        <CardDescription>{t`Monetary Metals buys and sells gold and silver at a spread to the London Fix price, or the spot price, depending on when the trade occurs.`}</CardDescription>
      </CardHeader>
      <CardContent>
        <Table striped>
          <TableHeader>
            <TableRow>
              <TableHead>{t`Tier`}</TableHead>
              <TableHead className="text-right">{t`Spread`}</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {FEE_SCHEDULE.map((tier) => (
              <TableRow key={tier.label}>
                <TableCell>{tier.label}</TableCell>
                <TableCell align="right" className="whitespace-nowrap">
                  {tier.displayRate}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
          <TableCaption className="flex items-center whitespace-nowrap">
            <InformationCircleIcon className="h-6 w-auto text-primary-light" />
            &nbsp;{t`${formattedMinAmount} minimum for all purchases`}
          </TableCaption>
        </Table>
      </CardContent>
    </Card>
  );
}

export const Route = createFileRoute("/_authenticated/spreads")({
  component: FeeTable,
});
